import React  , { useEffect, useState }  from 'react';
import Header from '../layouts/Header'
// import { Button } from "react-bootstrap"
import CheckIn from './CheckIn';
import CheckOut from './CheckOut';
import { useParams } from 'react-router-dom';
import Reservation from './Reservation';

import styled from 'styled-components';
import Reception  from './../images/Reception.webp'
import {RecepButton} from './../images/RecepButton.jsx'

function CheckInCheckOut(props)

{

       const [InColor, setInColor] =useState([]); 
        useEffect(()=> {
            
          setInColor((InColor)=>([]))
          setInColor((InColor) => ([
                    ...InColor,
                   "black"
                    ]));
                    setInColor((InColor) => ([
                      ...InColor,
                      "#EDD682"
                      ]));
                      setInColor((InColor) => ([
                    ...InColor,
                    "#2C2C2C"
                  ]));
                  setInColor((InColor) => ([
                    ...InColor,
                    "#2C2C2C"
                  ]));
                  setInColor((InColor) => ([
                        ...InColor,
                        "#2C2C2C"
                      ]));
                      setInColor((InColor) => ([
                        ...InColor,
                        "white"
                      ]));
                      setInColor((InColor) => ([
                        ...InColor,
                        "white"
                      ]))
            }, []);
      
        const params = useParams()
      
        const  myclick = (e) =>{
                const nextColor1 =  ["","#EDD682","#2C2C2C","#2C2C2C","#2C2C2C","white","white"];  
                const nextColor2 =  ["","#2C2C2C","#EDD682","#2C2C2C","white","#2C2C2C","white"]; 
                const nextColor3 =  ["","#2C2C2C","#2C2C2C","#EDD682","white","white","#2C2C2C"]; 
          switch (e) {
        case 1: 
        
        setInColor(nextColor1)
            break;
            case 2:
               
            setInColor(nextColor2)  
            break;
            case 3:
         
            setInColor(nextColor3)
            break;
    
        default:
            break;
    }
                
           setchinout(e)           
        }
const [chinout, setchinout] = useState(0);
const styles=styled.div`
          background-color:gray;
          text-align:left;
          padding:  20px 40px  30px 20px ;
          margin: 20px 40px  30px 20px;
.button {
    padding: auto;
     border-radius: 10px;
    margin: 15px;
    border: none;
    color: white;
    cursor: pointer;
    background-color: #4caf50;
    /* width: 20%; */
    font-size: 16px;
}

`

return(  
         <>
        <Header  />
   
        <div className="main-slide slidetype-2.3rem"  >
           
              <img  src={Reception} alt={"/" } style={{ width:"100%",height:"364.5px"}} /> 
              <div>
                   {/* <img  src={RecepButton} alt={"/" } style={{ width:"576px",height:"85px", marginTop:"-90px",textAlign:"center"}} />  */}
                   <RecepButton  Myonclick={myclick} color={InColor} style={{ width:"576px",height:"85px", marginTop:"-90px",textAlign:"center"}}/>
               </div>
           
          
            </div>

        {(() => { switch (chinout) {
        case 1:
         
             return(
              <Reservation params={params}/>
             )
               break;
       case 2 :
        return(
                <CheckIn  params={params}/>
        )

       break;
       case 3 :
        return(
        
         <CheckOut  params={params}/>
        )

       break;
        default:
                break;
       }   })()}
       </>
      
)


}
export default CheckInCheckOut